import {
  Injectable,
  Inject,
  ComponentFactoryResolver,
  Injector,
  ApplicationRef,
  EmbeddedViewRef,
  ComponentRef,
  EventEmitter,
} from '@angular/core';
import { NotificationType } from '../pg-notification.component';

import { DOCUMENT } from '@angular/common';
import { PgFlagNotificationComponent } from './pg-flag-notification.component';
import {
  PgFlagNotificationOptions,
  DefaultPgFlagNotificationOptions,
} from './pg-flag-notification-options';
import { take } from 'rxjs/operators';

export class PgFlagNotificationRef {
  afterDismissed = new EventEmitter<void>();

  constructor(
    private _componentRef: ComponentRef<PgFlagNotificationComponent>,
    private _options: PgFlagNotificationOptions
  ) {
    if (_options.timeout > 0) {
      setTimeout(() => {
        this.dismiss();
      }, _options.timeout);
    }

    _componentRef.instance.notificationHide.pipe(take(1)).subscribe(() => {
      this._destroyAndEmit();
    });
  }

  dismiss() {
    this._componentRef.instance.hide();
    setTimeout(() => {
      this._destroyAndEmit();
    }, 250);
  }

  private _destroyAndEmit() {
    this._componentRef.destroy();
    this.afterDismissed.emit();
  }
}

@Injectable({
  providedIn: 'root',
})
export class PgFlagNotificationService {
  constructor(
    @Inject(DOCUMENT) private _document: any,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _injector: Injector,
    private _appRef: ApplicationRef
  ) {}

  showFlagNotification(
    title: string,
    body?: string,
    action?: string,
    actionHandler?: Function,
    options?: PgFlagNotificationOptions
  ) {
    if (!options) {
      options = new DefaultPgFlagNotificationOptions();
    }
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(
      PgFlagNotificationComponent
    );

    const component = componentFactory.create(this._injector);
    component.instance.options = options;
    component.instance.data = {
      title,
      body,
      action,
      actionHandler,
    };

    const domElem = (component.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    domElem.style.visibility = 'hidden';

    this._document.body.appendChild(domElem);
    this._appRef.attachView(component.hostView);

    // We have no way to check when the element has been successfully attached to the
    // DOM so we are going to wait an arbitrary 250ms
    setTimeout(() => {
      component.instance.show();
    }, 250);

    return new PgFlagNotificationRef(component, options);
  }
}
